import { useMemo } from 'react';

import type { RequestedIncidentLocation } from '@ngsos/portal-core/commands';

import { IncidentListMapComponent } from '@/features/shared/map/IncidentListMapComponent';
import { callerMarker } from '@/features/shared/map/markers';

const LOCATION_PREVIEW_ZOOM = 17;
const LOCATION_MARKER_ID = 'CreateIncidentCallerLocationMarker';

function ignoreMarkerClick(): void {}

export type CreateIncidentLocationPreviewProps = {
  location: RequestedIncidentLocation;
};

export function CreateIncidentLocationPreview({ location }: CreateIncidentLocationPreviewProps) {
  const markers = useMemo(
    () => [callerMarker(LOCATION_MARKER_ID, [location.latitude, location.longitude])],
    [location.latitude, location.longitude],
  );

  return (
    <div data-testid="create-incident-location-preview" style={{ width: '100%', height: '14rem' }}>
      <IncidentListMapComponent
        center={location}
        zoom={LOCATION_PREVIEW_ZOOM}
        items={markers}
        disableControls
        onMarkerClicked={ignoreMarkerClick}
      />
    </div>
  );
}
